import {
  doc, updateDoc, addDoc, collection,
} from 'firebase/firestore';
import { db } from '../../lib/firebase';

// A decision (Approve / Reject) must carry a written reason — an approval or a
// rejection with no feedback is not actionable for the agent or the customer.
// Pure + unit-tested so the UI and any future server guard share one rule.
export const DECISION_STATUSES = ['approved', 'rejected'];

export function validateDecision(status, remark) {
  if (DECISION_STATUSES.includes(status) && !String(remark ?? '').trim()) {
    const verb = status === 'approved' ? 'approve' : 'reject';
    return { ok: false, error: `Add feedback / a remark before you ${verb} this request.` };
  }
  return { ok: true, error: '' };
}

// Manager decision: Approve / Reject a request (+ remark). The rules reject this
// for non-managers (status-change is manager/owner/HQ only, T-U3-005). Feedback
// is required for approve/reject — callers must pass validateDecision() first.
export function updateRequestStatus(requestId, status, remark, actor) {
  return updateDoc(doc(db, 'requests', requestId), {
    status,
    remark: remark ?? '',
    decidedBy: actor?.uid ?? null,
    decidedByName: actor?.name ?? null,
    updatedBy: actor?.uid ?? null,
    updatedByName: actor?.name ?? null,
    updatedAt: Date.now(),
  });
}

// Agent (or anyone in scope) annotates a request WITHOUT changing its status —
// allowed by the rules because `status` is unchanged.
export function setRequestRemark(requestId, remark, actor) {
  return updateDoc(doc(db, 'requests', requestId), {
    remark: remark ?? '',
    updatedBy: actor?.uid ?? null,
    updatedByName: actor?.name ?? null,
    updatedAt: Date.now(),
  });
}

// Log a new customer request/feedback. tenantId + territoryId must be in the
// caller's scope or the rules reject the write. Derive both from the chosen lead.
export function createRequest({
  tenantId, leadId, territoryId, customerName, type, text,
}, actor) {
  const now = Date.now();
  return addDoc(collection(db, 'requests'), {
    tenantId,
    leadId: leadId ?? null,
    territoryId,
    customerName: customerName ?? '',
    type: type ?? 'request',
    text: text ?? '',
    status: 'received',
    remark: '',
    createdBy: actor?.uid ?? null,
    updatedBy: actor?.uid ?? null,
    updatedByName: actor?.name ?? null,
    createdAt: now,
    updatedAt: now,
  });
}
